module.exports = __webpack_public_path__ + "img/coin.6c52e756.png";